import { Component, OnInit } from '@angular/core';
import { PersonItem } from '@models/custom-fields.model';
import { UserInfo } from '@models/user-profile.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ModalService } from '@services/modal/modal.service';
import { SessionService } from '@services/session/session.service';
import { UserProfileComponent } from '@shared-components/user-profile/user-profile.component';

@Component({
  selector: 'ts-ofo-indicator',
  templateUrl: './ofo-indicator.component.html',
  imports: [TranslationPipe]
})
export class OfoIndicatorComponent implements OnInit {
  person: PersonItem;
  current_user_id: UserInfo | undefined;

  constructor(
    private modal_svc: ModalService,
    private activity_manager_svc: ActivityManagerService,
    private session_svc: SessionService
  ) {}

  ngOnInit(): void {
    this.person = this.activity_manager_svc.state().getOrderForPerson()!;
    this.current_user_id = this.session_svc.getUser();
  }

  openProfile(): void {
    this.modal_svc.open(UserProfileComponent, {
      backdrop: 'static',
      centered: true
    });
  }
}
